import { Dropdown, DropdownTrigger, DropdownContent } from 'components/UI/V3/Dropdown';
import { DatePicker } from 'components/UI/V3/DatePicker/DatePicker';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import moment, { Moment } from 'moment';
import { FunctionComponent, useState } from 'react';
import styles from './DatePickerDropdown.module.scss';

/**
 * DatePickerDropdown Component
 * Combines DatePicker with Dropdown to create a custom date input with formatted display
 */
interface DatePickerDropdownProps {
    value: Moment | null;
    onChange: (date: Moment | null) => void;
    placeholder?: string;
    disabled?: boolean;
    label?: string;
    className?: string;
}

export const DatePickerDropdown: FunctionComponent<DatePickerDropdownProps> = ({
    value,
    onChange,
    placeholder = 'Select date',
    disabled = false,
    label,
    className
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const formatDate = (date: Moment | null): string => {
        if (!date) return '';
        return date.format('MMM DD, YYYY');
    };

    const handleDateChange = (newDate: Moment | null) => {
        onChange(newDate);
        setIsOpen(false);
    };

    return (
        <div className={className}>
            {label && <Label className={styles.label}>{label}</Label>}
            <Dropdown
                open={isOpen}
                onOpenChange={setIsOpen}
            >
                <DropdownTrigger disabled={disabled}>
                    <div className={styles.trigger}>
                        {formatDate(value) || <span className={styles.placeholder}>{placeholder}</span>}
                    </div>
                </DropdownTrigger>
                <DropdownContent
                    align="start"
                    sideOffset={4}
                    className={styles.datePicker}
                    showBottomModalOnMobile={false}
                >
                    <DatePicker
                        value={value}
                        onChange={handleDateChange}
                        timeZone={moment.tz.guess()}
                    />
                </DropdownContent>
            </Dropdown>
        </div>
    );
};
